import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import config from "../../api/config";
import { stripeService } from "../../api/stripe.service";
import Loader from "../../assets/images/loader-2.gif";
import useSourAlert from "../../hooks/useSourAlert";
import SourAlert from "../../components/elements/SourAlert";

const stripePromise = loadStripe(config.stripeKey);

export default function RedirectToCheckout({ planData }) {
	const [error, setError] = useState(null);
	const [alertProps, showAlert] = useSourAlert();

	useEffect(() => {
		const redirect = async () => {
			try {
				const body = JSON.stringify({ plan: planData.id });
				const session = await stripeService.createSession(body);

				if (session.id) {
					const stripe = await stripePromise;
					const { error } = await stripe.redirectToCheckout({
						sessionId: session.id,
					});
					if (error) {
						console.error("Error en redirectToCheckout:", error);
						if (session.url) {
							window.location.href = session.url;
						}
					}
				} else if (session.url) {
					window.location.href = session.url;
				} else {
					console.error(
						"No se devolvió ni session.id ni session.url"
					);
				}
			} catch (error) {
				setError(error);
				console.error("Error creando la sesión:", error);
			}
		};

		redirect();
	}, [planData]);

	useEffect(() => {
		if (error) {
			showAlert({
				type: "error",
				title: "Error",
				description:
					error.detail ||
					"You cannot have two of the same subscription at the same time. Please select a different one.",
				okButtonText: "Retry",
				onOk: () => window.location.reload(),
			});
		}
	}, [error, showAlert]);

	return (
		<div className="redirect">
			<img src={Loader} alt="Loading..." className="loader" />
			<SourAlert {...alertProps} />
		</div>
	);
}
